export const companyInfo = {
  name: "EBON Media Solutions",
  shortName: "EBON",
  tagline: "Innovative Technology. Intelligent Automation. Sustainable Growth.",
  eyebrow: "AI • SOFTWARE • DIGITAL GROWTH",
  heroHeadingLine1: "Transform Ideas Into",
  heroHeadingLine2: "Powerful Digital Solutions",
  heroDescription: "EBON Media Solutions helps businesses grow through custom software development, AI-powered digital solutions, hybrid mobile app development, SaaS platforms, ERP systems, and performance-focused digital marketing in India, USA, UK & Canada.",
  heroTrustMessage: "Engineering scalable digital experiences designed for long-term growth and continuous website care.",
  founder: {
    name: "Pooja Kuril",
    title: "Founder & Director",
    photo: "/assets/pooja-kuril-founder.jpg",
    avatar: "/assets/pooja-kuril-avatar.jpg",
    bio: "Pooja Kuril leads EBON Media Solutions with an unwavering focus on engineering excellence, human-centered UI/UX, and enduring client partnerships that ensure long-term website performance and market reach across the US, UK, and Canada.",
    quote: "We don't simply launch a website and disappear. We maintain close, long-term partnerships with our clients—taking care of their digital products continuously so they consistently capture market opportunities."
  },
  contact: {
    phone: "+91 7307718079",
    phoneDisplay: "+91 7307718079",
    email: "info@ebonmedia.com",
    workModel: "Remote-First & Distributed Global Engineering Pods",
    globalReach: "Serving Businesses in the USA, UK & Canada"
  },
  targetMarkets: [
    { code: 'US', name: 'United States', flag: '🇺🇸', currency: 'USD ($)', timezone: 'EST / CST / PST Aligned' },
    { code: 'UK', name: 'United Kingdom', flag: '🇬🇧', currency: 'GBP (£)', timezone: 'GMT / BST Aligned' },
    { code: 'CA', name: 'Canada', flag: '🇨🇦', currency: 'CAD ($)', timezone: 'EST / PST Aligned' }
  ],
  payments: {
    paypalUrl: "https://paypal.me/ebonmediasolutions",
    stripeUrl: "https://buy.stripe.com/ebonmediasolutions",
    supportedCurrencies: ["USD ($)", "GBP (£)", "CAD ($)", "INR (₹)", "EUR (€)"]
  },
  socials: {
    linkedin: "https://linkedin.com/company/ebon-media-solutions",
    twitter: "https://twitter.com/ebonmedia",
    facebook: "https://facebook.com/ebonmediasolutions",
    instagram: "https://instagram.com/ebonmediasolutions",
    youtube: "https://youtube.com/@ebonmediasolutions"
  },
  stats: [
    { value: "250+", label: "Projects Completed", sublabel: "Across US, UK & Canada" },
    { value: "100+", label: "Active Client Partners", sublabel: "B2B, retail & tech firms" },
    { value: "15+", label: "Industry Domains", sublabel: "Consulting, fintech, healthcare & retail" },
    { value: "99%", label: "Client Retention Rate", sublabel: "Long-term maintenance partnerships" }
  ],
  longTermCommitment: {
    headline: "Our Commitment: Long-Term Relationship & Continuous Website Care",
    description: "A website is not a one-time project—it is your business's most critical digital asset. We maintain active, long-term relationships with every customer to handle updates, security, speed, and continuous digital marketing optimization so you reliably win business from your target market.",
    pillars: [
      {
        title: "Ongoing Website Health & Security",
        detail: "Continuous dependency updates, vulnerability patching, automated backups, and 99.9% uptime monitoring."
      },
      {
        title: "Speed & Core Web Vitals Maintenance",
        detail: "Continuous performance audits ensuring sub-second load times and flawless mobile responsiveness."
      },
      {
        title: "Persistent Search & Keyword Evolution",
        detail: "Adapting on-page SEO, content strategy, and search engine algorithm updates to protect and grow rankings."
      },
      {
        title: "Commercial Conversion Refinement",
        detail: "A/B testing landing pages and form funnels to turn market traffic into qualified client inquiries."
      }
    ]
  },
  coreValues: [
    {
      title: "Business-First Engineering",
      description: "Every line of code and architectural decision aligns directly with revenue, efficiency, and commercial KPIs."
    },
    {
      title: "Long-Term Relationship Focus",
      description: "We partner for the long haul. Post-launch maintenance, iterative growth, and proactive technical care."
    },
    {
      title: "Transparent Collaboration",
      description: "Clear sprint milestones, proactive communications across time zones, and honest guidance without jargon."
    },
    {
      title: "Quality Over Decorative Gimmicks",
      description: "Solid, accessible, lightning-fast software architectures built to scale without technical debt."
    }
  ]
};
